import { FileText, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function CGV() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Navigation */}
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2">
              <FileText className="h-6 w-6 text-[#2563EB]" />
              <span className="font-bold text-lg text-[#0F172A]">CFE Auto-Entrepreneur</span>
            </a>
            <Button 
              variant="ghost" 
              onClick={() => navigate('/')}
              className="text-[#475569]"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Retour
            </Button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-slate-200 p-8 sm:p-12">
          <h1 className="text-3xl font-bold text-[#0F172A] mb-8">Conditions Générales de Vente</h1>
          
          <div className="legal-content text-[#475569]">
            <h2 className="text-[#0F172A] font-semibold">Article 1 - Objet</h2>
            <p>
              Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles 
              entre le site cfe-autoentrepreneur.fr et ses utilisateurs pour le service de génération 
              de déclaration CFE.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 2 - Service proposé</h2>
            <p>
              Le service consiste en la mise à disposition d'un formulaire en ligne permettant de 
              générer un document PDF pré-rempli conforme au formulaire 1447-C-SD de déclaration 
              initiale de Cotisation Foncière des Entreprises (CFE).
            </p>
            <p>
              Le document généré est un outil d'aide au remplissage. Il appartient à l'utilisateur 
              de vérifier l'exactitude des informations avant envoi aux services fiscaux.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 3 - Prix</h2>
            <p>
              Le prix du service est de <strong>7,99 € TTC</strong> par déclaration générée.
            </p>
            <p>
              Ce prix comprend :
            </p>
            <ul>
              <li>L'accès au formulaire de saisie guidé</li>
              <li>La génération d'un aperçu gratuit</li>
              <li>Le téléchargement du document PDF complet après paiement</li>
            </ul>
            <p>
              Il s'agit d'un paiement unique. Aucun abonnement n'est souscrit.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 4 - Paiement</h2>
            <p>
              Le paiement s'effectue en ligne par carte bancaire via la plateforme sécurisée Stripe. 
              Les données de paiement sont traitées directement par Stripe et ne transitent pas par 
              nos serveurs.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 5 - Livraison</h2>
            <p>
              Le document PDF est disponible au téléchargement immédiatement après confirmation 
              du paiement. Un lien de téléchargement est affiché sur la page de confirmation.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 6 - Droit de rétractation</h2>
            <p>
              Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation 
              ne peut être exercé pour les contrats de fourniture de contenu numérique non fourni 
              sur un support matériel dont l'exécution a commencé avec l'accord du consommateur.
            </p>
            <p>
              En procédant au paiement, l'utilisateur accepte expressément que le service commence 
              immédiatement et renonce à son droit de rétractation.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 7 - Responsabilité</h2>
            <p>
              <strong>Ce service n'est pas affilié à l'administration fiscale française.</strong>
            </p>
            <p>
              <strong>Ce service ne constitue pas un conseil fiscal.</strong>
            </p>
            <p>
              Le service fourni est un outil d'aide au remplissage administratif. 
              <strong> Le document généré doit être vérifié par l'utilisateur avant envoi.</strong>
            </p>
            <p>
              L'éditeur ne saurait être tenu responsable :
            </p>
            <ul>
              <li>Des erreurs dans les informations saisies par l'utilisateur</li>
              <li>De l'utilisation du document généré</li>
              <li>Des décisions prises par l'administration fiscale</li>
              <li>Des conséquences financières ou juridiques liées à la déclaration</li>
            </ul>

            <h2 className="text-[#0F172A] font-semibold">Article 8 - Réclamations</h2>
            <p>
              Pour toute réclamation concernant le service, vous pouvez nous contacter à 
              l'adresse suivante : contact@cfe-autoentrepreneur.fr
            </p>
            <p>
              En cas de problème technique empêchant le téléchargement du document, nous nous 
              engageons à fournir une solution dans les meilleurs délais.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 9 - Modification des CGV</h2>
            <p>
              L'éditeur se réserve le droit de modifier les présentes CGV à tout moment. Les 
              conditions applicables sont celles en vigueur au moment de la commande.
            </p>

            <h2 className="text-[#0F172A] font-semibold">Article 10 - Droit applicable</h2>
            <p>
              Les présentes CGV sont soumises au droit français. En cas de litige, et après 
              tentative de résolution amiable, les tribunaux français seront compétents.
            </p>

            <p className="text-sm text-[#94A3B8] mt-8">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-4 text-center text-sm text-[#94A3B8] border-t border-slate-200">
        <p>© {new Date().getFullYear()} CFE Auto-Entrepreneur. Tous droits réservés.</p>
      </footer>
    </div>
  );
}
